











































import { Component, Vue } from "vue-property-decorator";
import { AbsenceTypeEditModel, AbsenceTypeEnum } from "@/services/api/nswag/stapiclient_generated";
import { stAbsenceTypeApi } from "@/services/st-api";
import StRatePicker from "@/components/basic/StRatePicker.vue";
import SlideIn from "@/components/basic/SlideIn.vue";
import StInput2 from "@/components/basic/StInput2.vue";
import StToggle from "@/components/basic/StToggle.vue";

@Component({
    components: {
      StToggle,
      StInput2,
      SlideIn,
      StRatePicker,
    },
  })
  export default class AbsenceTypeEdit extends Vue {
    private id: number = 0;
    private item: AbsenceTypeEditModel = new AbsenceTypeEditModel();
    private loading: boolean = true;
    private saving: boolean = false;
    private listPage: string = 'AbsenceTypes';

    openSlideIn() {
      (this.$refs.slideIn as SlideIn).open();
    }

    closeSlideIn() {
      (this.$refs.slideIn as SlideIn).close();
    }

    slideOutClosed() {
      this.$router.push({ name: this.listPage });
    }

    created() {
      this.id = parseInt(this.$route.params.id);
    }

    async mounted() {
      this.openSlideIn();
      this.item = this.id == 0 ? await stAbsenceTypeApi.getNewEditModel() : await stAbsenceTypeApi.getEditModel(this.id);
      this.loading = false;
    }

    get absencyTypeEnums(){
      return [
        {id:AbsenceTypeEnum.Vacation, description: this.$t('Urlaub')},
        {id:AbsenceTypeEnum.Overtime, description: this.$t('Überstunden')},
        {id:AbsenceTypeEnum.Sick, description: this.$t('Krankheit')},
        {id:AbsenceTypeEnum.Other, description: this.$t('Sonstiges')}
      ]
    }

    async submit() {
      try {
        this.saving = true;
        if (this.item.id == 0) {
          await stAbsenceTypeApi.insert(this.item);
        } else {
          await stAbsenceTypeApi.put(this.item);
        }
        this.closeSlideIn();
      } finally {
        this.saving = false;
      }
    }
  }
